var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "page-outline",
    { attrs: { title: _vm.$t("businessDocuments.cntcts_lst") } },
    [
      _c("template", { slot: "pageContent" }, [
        _vm.isSmartphoneOS
          ? _c(
              "div",
              [
                false
                  ? _c(
                      "f7-navbar",
                      { staticClass: "position-absolute t-44px" },
                      [
                        _c(
                          "b-row",
                          { staticClass: "text-center w-100 no-gutters" },
                          [
                            _c(
                              "div",
                              [
                                _c(
                                  "b-button",
                                  {
                                    staticClass: "statusButton",
                                    class:
                                      _vm.currentRole === "simple"
                                        ? "navbar-button-selected"
                                        : "navbar-button",
                                    attrs: {
                                      variant: "primary",
                                      "tab-link": ".contactTab1",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.changeCurrentRole("simple")
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          _vm.$t("common.contacts_label")
                                        ) +
                                        "\n              "
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              [
                                _c(
                                  "b-button",
                                  {
                                    staticClass: "statusButton",
                                    class:
                                      _vm.currentRole === "group"
                                        ? "navbar-button-selected"
                                        : "navbar-button",
                                    attrs: {
                                      variant: "primary",
                                      "tab-link": ".contactTab2",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.changeCurrentRole("group")
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(_vm.$t("common.groups_label")) +
                                        "\n              "
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ]
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "listPage" },
          [
            _c(
              "b-row",
              [
                _c(
                  "b-col",
                  {
                    staticClass: "d-flex justify-content-center",
                    attrs: { cols: "12" },
                  },
                  [
                    _c("f7-searchbar", {
                      staticClass: "search webdatalist",
                      attrs: {
                        "cancel-link": _vm.$t("common.cncl"),
                        "search-list": "#contacts-list",
                        placeholder: _vm.searchInLabel,
                        "clear-button": true,
                      },
                      on: {
                        "searchbar:search": _vm.onSearch,
                        "searchbar:clear": _vm.onClear,
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            !_vm.isSmartphoneOS && false
              ? _c(
                  "b-row",
                  [
                    _c("b-col", [
                      _c(
                        "div",
                        { staticClass: "contactButtonContainer" },
                        [
                          _c(
                            "f7-grid",
                            { attrs: { "no-gutter": "" } },
                            [
                              _c(
                                "f7-col",
                                {
                                  staticClass: "pilotageTabController",
                                  attrs: { width: "50" },
                                },
                                [
                                  _c(
                                    "f7-link",
                                    {
                                      staticClass:
                                        "pilotageLink border-top-left-radius-10px",
                                      class: {
                                        tabActive: _vm.currentRole === "simple",
                                        tabUnactive:
                                          _vm.currentRole !== "simple",
                                      },
                                      attrs: {
                                        "tab-link": ".contactTab1",
                                        active: "",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.changeCurrentRole("simple")
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                      " +
                                          _vm._s(
                                            _vm.$t("common.contacts_label")
                                          ) +
                                          "\n                    "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "f7-col",
                                {
                                  staticClass: "pilotageTabController",
                                  attrs: { width: "50" },
                                },
                                [
                                  _c(
                                    "f7-link",
                                    {
                                      staticClass:
                                        "pilotageLink border-top-left-radius-10px",
                                      class: {
                                        tabActive: _vm.currentRole === "group",
                                        tabUnactive:
                                          _vm.currentRole !== "group",
                                      },
                                      attrs: { "tab-link": ".contactTab2" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.changeCurrentRole("group")
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                      " +
                                          _vm._s(
                                            _vm.$t("common.groups_label")
                                          ) +
                                          "\n                    "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "b-row",
              { staticClass: "my-3 justify-content-start" },
              [
                _vm.currentRole === "simple"
                  ? _c(
                      "b-col",
                      { attrs: { xl: "2", cols: "12", sm: "6" } },
                      [
                        _c(
                          "b-button",
                          {
                            attrs: {
                              variant: "secondary",
                              disabled: _vm.canAdd,
                            },
                            on: { click: _vm.OpenFormsPageContact },
                          },
                          [
                            _c("i", {
                              staticClass: "fa-light fa-plus fs-17px",
                            }),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(_vm._s(_vm.$t("common.add_label"))),
                            ]),
                          ]
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "b-col",
                  { attrs: { xl: "2", cols: "12", sm: "6" } },
                  [
                    _c(
                      "b-button",
                      {
                        attrs: { variant: "secondary" },
                        on: {
                          click: function ($event) {
                            return _vm.extractCSV(
                              _vm.contacts,
                              _vm.contactGroups
                            )
                          },
                        },
                      },
                      [
                        _c("i", { staticClass: "fa-light fa-upload fs-17px" }),
                        _vm._v(" "),
                        _c("span", [_vm._v(_vm._s(_vm.$t("common.extract")))]),
                      ]
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.currentRole === "group"
                  ? _c(
                      "b-col",
                      { attrs: { xl: "2", cols: "12", sm: "6" } },
                      [
                        _c(
                          "b-button",
                          {
                            attrs: { variant: "secondary" },
                            on: { click: _vm.OpenFormsPageContactGroup },
                          },
                          [
                            _c("i", {
                              staticClass: "fa-light fa-plus fs-17px",
                            }),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(_vm._s(_vm.$t("common.add_label"))),
                            ]),
                          ]
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-row",
              [
                _c(
                  "b-col",
                  [
                    _vm.activateSpinner
                      ? _c("div", [_c("spinner")], 1)
                      : _c(
                          "f7-tabs",
                          [
                            _c(
                              "f7-tab",
                              {
                                staticClass: "contactTab1",
                                attrs: { active: "" },
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "itemList" },
                                  [
                                    _c("cm-contact-list", {
                                      key: _vm.refreshKey,
                                      attrs: {
                                        filterBy: _vm.filterBy,
                                        contacts: _vm.contacts,
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "f7-tab",
                              { staticClass: "contactTab2" },
                              [
                                !_vm.isSmartphoneOS
                                  ? _c("f7-searchbar", {
                                      staticClass: "webdatalist",
                                      attrs: {
                                        "cancel-link": "Cancel",
                                        "search-list": "#group-list",
                                        placeholder: _vm.searchInLabel,
                                      },
                                      on: {
                                        "searchbar:search": _vm.onGroupSearch,
                                        "searchbar:clear": _vm.onGroupClear,
                                      },
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "itemList" },
                                  [
                                    _c("cm-contact-group-list", {
                                      key: _vm.refreshKey,
                                      attrs: {
                                        filterBy: _vm.groupFilterBy,
                                        contactGroups: _vm.contactGroups,
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "toolbarPageBottomBlankContactPage" }),
          ],
          1
        ),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }